import { elementExists } from "../../core/utils";

const CollectionProductGrid = function(){

    const container = document.querySelector( 'collection-product-grid' );
    if( elementExists( container )){
        const filtersContainer = container.querySelector( '[collection-product-grid-filters]' );
        const resultContainer = container.querySelector( '[collection-product-grid-results]' );
        const baseUrl = container.dataset.url;
        let btnToggle = null;
        let filterForm = null
        let btnRemoveFilters = null
        let filterParams = ''
        let closeButtons = null;
        let openFilterHandle = null
        const filterType = typeof( container.dataset.filterType ) !== 'undefined' ? container.dataset.filterType : false;

        const initFunctions = function(){
            addRemoveButtons();
            initForm();
        }
        /**
         * Get the remove filter buttons and add the event listener
         */
        const addRemoveButtons = function(){
            btnRemoveFilters = container.querySelectorAll( '[collection-product-grid-remove-filter]')
            if( elementExists( btnRemoveFilters , true )){
                btnRemoveFilters.forEach( btn =>  {
                    btn.addEventListener( 'click' , function( evt ){
                        evt.preventDefault();
                        openFilterHandle = null;
                        let href =  evt.currentTarget.getAttribute( 'href');
                        href = href.replace( baseUrl , '' ).replace(  '?' , '');
                        filterParams = href;
                        populateGrid(  )
                    });
                });
            }
        }

        /**
         *  Get the filter params from the form
         * @returns {string} filterParams
         */
        const getFilterParams = function(){
            let formData = new FormData(filterForm);         
            let search = new URLSearchParams(formData);
            filterParams = search.toString();
            return filterParams;
        }

        /** 
         *  Set the open Filter handle
         */
        const setOpenFilterHandle = function(){
            const openDropdown = filtersContainer.querySelector( '.dropdown-toggle.show' );
            const filterGroup = openDropdown.closest( '.filter-group' );
            openFilterHandle = filterGroup.dataset.filterGroup;
        }

        /**
         * Submit the filter form
         */
        const submitFilter = function(  ){
            setOpenFilterHandle();
            getFilterParams();
            populateGrid();
        }

        /**
         * @param {*} url 
         * Populate the grid with ajax results from the proviced url
         */
        const populateGrid = function( url = false  ){
            if( !url ) {
                // Wellness pages set data-layout="wellness-layout" on <html> server-side (see
                // layout/theme.wellness.liquid). collection.ajax.liquid's template.suffix is
                // just "ajax" — never "wellness" — so without this, product-grid-item.liquid's
                // wellness check would hide every Wellness-typed tile whenever a filter re-fetches.
                const isWellnessPage = document.documentElement.getAttribute('data-layout') === 'wellness-layout';
                const view = isWellnessPage ? 'ajax-wellness' : 'ajax';
                url = baseUrl + '?' + filterParams + '&view=' + view;
            }
            updateUrl();
            if( filterType ) url += '&type=' + filterType;
            fetch( url  )
            .then( res => {
                if( res.ok ){
                    return res.text();
                }
                return false;
            })
            .then( text => {
                if( text ){
                    let div = document.createElement("div");
                    div.innerHTML = text;
                    const resResultsContainer = div.querySelector( '[collection-product-grid-results]' );
                    const resFiltersContainer = div.querySelector( '[collection-product-grid-filters]' );
                    resultContainer.innerHTML = resResultsContainer.innerHTML;
                    filtersContainer.innerHTML = resFiltersContainer.innerHTML;
                    if( openFilterHandle !== null ){
                        const dropdownToggle = document.querySelector('[data-filter-group="'+ openFilterHandle+'"]')
                        .querySelector( '.dropdown-toggle');
                        dropdownToggle.click();
                    }
                    initFunctions();
                }
            })

        }
        /**
         * Update the browser url without reloading the page 
         * based on the filter params
         */
        const updateUrl = function(){
            var newRelativePathQuery = window.location.pathname + '?' + filterParams
            history.pushState(null, '', newRelativePathQuery);
        }

        /**
         * set the filter form and add the event listerners
         */
        const initForm = function(){
            filterForm = filtersContainer.querySelector( '[collection-product-grid-filters-form]' );

            if ( filterForm ) {
                filterForm.addEventListener( 'submit' , function( evt ){
                    evt.preventDefault();
                    submitFilter();
                });

                filterForm.querySelectorAll( 'input' ).forEach( function( input ){
                    input.addEventListener( 'change' , function( evt ){
                        submitFilter();
                    });
                });
            }
            

            btnToggle = container.querySelector( '[collection-product-grid-filter-toggle]' );
            
            if ( btnToggle ) {
                btnToggle.addEventListener( 'click' , function( evt ){
                    filtersContainer.classList.add( 'active' );
                    document.body.classList.add('scroll-lock');
                });
            }
            
            closeButtons = container.querySelectorAll( '[collection-product-grid-filter-close]' );
            
            if ( closeButtons.length > 0 ) {
                closeButtons.forEach( btn => {
                    btn.addEventListener( 'click' , function( evt ){
                        filtersContainer.classList.remove( 'active' );
                        document.body.classList.remove( 'scroll-lock');
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                    });
                });
            }
        }
        // initialize
        initFunctions();
    }
}

export default CollectionProductGrid;